import { Colors } from "../../../consts/Colors";
import FONTS from "../../../consts/Fonts";
import { tags } from "../../../consts/Tags";

export default class ButtonRounded extends Phaser.GameObjects.Container {
    constructor(scene, x, y, {width = 1, height = 1, text, textColor = Colors.Text.White, textHoverColor, color, hoverColor, borderColor, borderHoverColor, borderRadius = 24}) {
        super(scene, x, y, []);

        this.soundManager = scene.soundManager

        this.scene = scene;
        scene.add.existing(this);

        this.isLocked = false

        this.color = color
        this.hoverColor = hoverColor
        this.borderColor = borderColor
        this.borderHoverColor = borderHoverColor
        this.textColor = textColor
        this.textHoverColor = textHoverColor

        this.addBody({width, height, text, textColor, color, hoverColor, borderColor, borderRadius})        
        // Ajout intéractions
        this.setInteractive({useHandCursor: true});

        this.on('pointerover', () => {
            this.pointerOver()
        })

        this.on('pointerout', () => {
            this.pointerOut()
        })
    }

    setClickFunction( clickFunction ){
        this.removeListener('pointerup'); // Supprime les anciens listeners pour éviter les conflits
        this.on('pointerup', () => {
                this.soundManager.playOnce('Button3')
                this.scene.tweens.add({
                    targets: this,
                    scale: 0.9,
                    duration: 100,
                    yoyo: true,
                    ease: 'Cubic.easeInOut',
                    onComplete: () => {
                        clickFunction(this);
                    }
                })
        }, this.scene);
    }

    // -- A completer dans les class enfants

    addBody({width, height, text, textColor, color, borderColor, borderRadius}){
        this.background = this.scene.add.rexRoundRectangle(0, 0, width, height, borderRadius, color);
        // this.background.setStrokeStyle(4, color);
        if(borderColor)
            this.background.setStrokeStyle(4, borderColor);

        this.add(this.background);

        this.textElmt = this.scene.add.rexTagText(0, 0, text, {
            fontFamily: FONTS.InterSemiBold,
            fontSize: '22px',
            color: textColor,
            align: "center",
            backgroundColor: 'transparent',
            tags:tags
        });
        this.textElmt.setOrigin(0.5);
        this.add(this.textElmt);

        if(width == 1 && height == 1){
            this.adjustToTextPadding(32, 16);
            this.background.radius = this.background.height / 2;
        }

        this.setSize(this.background.width, this.background.height);
    }

    pointerOver(){
        if(this.hoverColor)
            this.scene.tweenShapeColor(this.background, this.hoverColor, 200);

        if(this.textHoverColor)
            this.scene.tweenTextColor(this.textElmt, this.textHoverColor, 200);

        if(this.borderHoverColor)
            this.background.setStrokeStyle(4, this.borderHoverColor);
    }

    pointerOut(){
        if(this.hoverColor)
            this.scene.tweenShapeColor(this.background, this.color, 200);

        if(this.textHoverColor)
            this.scene.tweenTextColor(this.textElmt, this.textColor, 200);

        if(this.borderColor){
            this.background.setStrokeStyle(4, this.borderColor);
        }else{
            this.background.setStrokeStyle(0);
        }
    }

    setLocked(){
        // Ajout de l'état bloqué
        this.isLocked = true
        this.disableInteractive();
        this.setAlpha(0.5); // Optionnel : rendre le bouton semi-transparent pour indiquer qu'il est bloqué
        if(this.borderColor)
            this.background.setStrokeStyle(4, this.borderColor, 0.2); // Optionnel : changer la bordure pour indiquer qu'il est bloqué
    }

    setUnlocked(){
        // Ajout de l'état débloqué
        this.isLocked = false
        this.setInteractive({useHandCursor: true});
        this.setAlpha(1); // Rendre le bouton complètement opaque
        if(this.borderColor)
            this.background.setStrokeStyle(4, this.borderColor, 1); // Optionnel : changer la bordure pour indiquer qu'il est bloqué
    }

    adjustToTextPadding(paddingX = 32, paddingY = 16){
        const textWidth = this.textElmt.width;
        const textHeight = this.textElmt.height;

        const newWidth = textWidth + paddingX * 2;
        const newHeight = textHeight + paddingY * 2;
        this.background.width = newWidth;
        this.background.height = newHeight;
        this.setSize(this.background.width, this.background.height);
    }

    setText(newText){
        this.textElmt.setText(newText);
        this.adjustToTextPadding(32, 16);
    }
}